//External
import React from "react";

/*******************
  @Purpose :  used for Booking steps
  @Parameter : {step}
  @Author : INIC
  *******************/
const BookingSteps = ({ step }) => {
  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* Step bar :  Start */}
      <div className="step-list">
        <ul className="list-unstyled mb-0 d-flex step-bar">
          <li className="active">
            <span></span>
            Select
          </li>
          <li
            className={
              parseInt(step) <= 3 && parseInt(step) >= 2 ? "active" : ""
            }
          >
            <span></span>
            Pay
          </li>
          <li className={parseInt(step) == 3 ? "active" : ""}>
            <span></span>
            Done
          </li>
        </ul>
      </div>
      {/* Step bar : End */}
    </>
  );
};

export default BookingSteps;
